<script setup lang="ts">
    /**
     * This component should only be used within the ExternalVideo component.
     */

    defineProps<{ src: string }>();

    useHead({
        script: [
            {
                src: 'https://player.vimeo.com/api/player.js',
                defer: true
            }
        ]
    });
</script>

<template>
    <iframe
        :src="src"
        title=""
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
</template>
